var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-left: -15px;\n  margin-right: -15px;\n  &.product-package {\n    padding-top: 5px !important;\n    padding-bottom: 0px !important;\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n  &.off {\n    color: #999 !important;\n  }\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n'], ['\n  margin-left: -15px;\n  margin-right: -15px;\n  &.product-package {\n    padding-top: 5px !important;\n    padding-bottom: 0px !important;\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n  &.off {\n    color: #999 !important;\n  }\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 0px;\n  float: left;\n  font-weight: 600;\n'], ['\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 0px;\n  float: left;\n  font-weight: 600;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 0px;\n  float: right;\n  text-align: right;\n  font-weight: 600;\n'], ['\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 0px;\n  float: right;\n  text-align: right;\n  font-weight: 600;\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
var Container = styled.div(_templateObject);
var Title = styled.div(_templateObject2);
var Price = styled.div(_templateObject3);

var ProductHeader = function (_Component) {
  _inherits(ProductHeader, _Component);

  function ProductHeader() {
    _classCallCheck(this, ProductHeader);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.toggleClicked = _this.toggleClicked.bind(_this);
    return _this;
  }

  ProductHeader.prototype.toggleClicked = function toggleClicked() {
    var _props = this.props,
        toggle = _props.toggle,
        selected = _props.selected;
    toggle(!selected);
  };

  ProductHeader.prototype.render = function render() {
    var _props2 = this.props,
        title = _props2.title,
        price = _props2.price,
        selected = _props2.selected,
        notSelectedText = _props2.notSelectedText,
        priceSuffix = _props2.priceSuffix;
    var offStyle = selected ? 'product-package' : 'product-package off';
    var pricing = 'R' + numeral(price).format('0,0');
    var productSelection = selected ? '' : notSelectedText;
    var productTitle = title + ' ' + productSelection;
    return React.createElement(Container, {
      className: 'space-below ' + offStyle
    }, React.createElement(Title, null, productTitle), selected && React.createElement(Price, null, pricing + '  ' + priceSuffix));
  };

  return ProductHeader;
}(Component);

export default ProductHeader;